export const CPF_REGEX = /^[0-9]{11}$/;
export const CNPJ_REGEX = /^[A-Za-z0-9]{12}\d{2}$/;
